module.exports = __webpack_public_path__ + "img/1215-child@2x.4892df6c.jpg";